import React from 'react';

/**
 * Parça bilgisi görüntüleme bölümü - Mevcut parça seçildiğinde
 */
const PartDisplaySection = ({ selectedPart, th }) => {
    return (
        <>
            <div className="col-12 md:col-4">
                <div className="field">
                    <label className="font-semibold">{th('dealerPartsReturnProcess.partCode')}:</label>
                    <p className="mt-1 mb-0">{selectedPart?.partCode}</p>
                </div>
            </div>

            <div className="col-12 md:col-4">
                <div className="field">
                    <label className="font-semibold">{th('dealerPartsReturnProcess.partDesc')}:</label>
                    <p className="mt-1 mb-0">{selectedPart?.partDesc}</p>
                </div>
            </div>

            <div className="col-12 md:col-4">
                <div className="field">
                    <label className="font-semibold">{th('dealerPartsReturnProcess.uom')}:</label>
                    <p className="mt-1 mb-0">{selectedPart?.uom}</p>
                </div>
            </div>
        </>
    );
};

export default PartDisplaySection;

